








import Vue from "vue";
import i18n from "../../../lang/i18n";
import Modal from "../../shared/modal/Modal.vue";
import { Component, Inject, Watch } from "vue-property-decorator";
import { ClosureService } from "../../../services/ClosureService";
import { ClosuresDTO } from "../../../model/data.model";
import {
  GetClosureResults,
  ClosureListItem,
  Page,
  SearchParams
} from "../../../model/component.model";
import ClosuresSearch from "./ClosuresSearch.vue";

@Component({
  components: {
    MbeModal: Modal,
    ClosuresSearch: ClosuresSearch
  }
})
export default class ClosuresList extends Vue {}
